import React from "react";
import "./RunningDownloadDialog.css";
import { ProgressBar } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { withTranslation } from "react-i18next";
import BaseDialog from "../baseDialog/BaseDialog";

const RunningDownloadDialog = props => (
  <BaseDialog
    show={props.show}
    onHide={props.onHide}
    noFooter={true}
    title={(
      <div>
        {props.progress < 0 ? <FontAwesomeIcon icon={faCircleNotch} spin /> : ""} {props.title}
      </div>
    )}
    body={(
      <div>
        {props.t("RunningDownloadDialog.Body")}
        {props.progress > 0 ? (
          <>
            <br />
            <ProgressBar
              now={props.progress}
              animated
              label={`${props.progress}%`}
            />
          </>
        ) : (
            <>
            <br /><FontAwesomeIcon icon={faCircleNotch} spin />
            </>
        )}
      </div>
    )}
  />
);

export default withTranslation()(RunningDownloadDialog);
